import React from "react";
import pic from "../assets/research.jpg";
const AboutUsIntro = () => {
  return (
    <div className="mx-auto flex flex-col items-center px-4 lg:max-w-[45rem] xl:max-w-[55rem] 2xl:max-w-[75rem]">
      <div className=" lg  flex flex-col pt-24 text-center md:pt-32 lg:pt-28 xl:pt-32 2xl:pt-44">
        <div className="xl-gap-7 flex flex-col justify-between gap-10 md:gap-12 lg:flex-row lg:gap-24">
          <div className="flex flex-col gap-5 lg:text-start">
            <h6 className="text-[#00378A]">About Us</h6>
            <h1>Learn More About Our Company</h1>
          </div>
          <div className="flex items-end lg:w-[46%] xl:w-[43%] 2xl:w-[33%]">
            <h6 className=" text-[#838B93] lg:text-end">
              Discover the dedicated and highly skilled professionals who make
              up our medical laboratory team. With a shared commitment to
              precision and quality, our experts bring a wealth of experience in
              various specialized fields, including pathology, and molecular
              diagnostics.
            </h6>
          </div>
        </div>
      </div>
      <img
        src={pic}
        className="standard-mt h-[25rem] w-full rounded-xl object-cover sm:h-[19rem]  md:h-[32.5rem] lg:h-[16rem] xl:h-[18rem] 2xl:h-[25rem]"
      />
      <div className="standard-mt flex flex-col items-center text-center">
        <h6 className="text-[#00378A]">Our Mission</h6>
        <h2>
          Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aliquam
          pretium hendrerit nunc non viverra. Nulla ipsum felis, suscipit in
          dolor sit amet, porttitor pulvinar lectus. Aliquam et sem eget.Lorem
          ipsum dolor sit amet, consectetur adipiscing elit. Aliquam pretium
          hendrerit nunc non viverra. Nulla ipsum felis, suscipit in dolor sit
          amet, porttitor pulvinar lectus. Aliquam et sem eget.
        </h2>
      </div>
    </div>
  );
};

export default AboutUsIntro;
